import { gql } from "@stadium/services/apollo-client";

export const PACKAGE_DATA = gql`
  fragment PackageData on Package {
    position
    id
    name
    intent
    packageIntentMappingKey
    price
    monthlyPrice
    displayOnFe
    active
    packageFeatures {
      id
      name
      internalName
      intent
      description
      amount
      usageLimits
      displayOnFe
      onboardingRequired
      active
      roleId
      permissions
    }
    packageDetail {
      id
      packageId
      popular
      default
      customPricing
      colorCode
      iconColor
      colorCodeBg
      displayMarkup
      colorCodeDark
      intakeFormUrl
      iconImageUrl
      bgImageUrl
      preferences {
        recommendedFor
        commonFeatures
        onDemandSwagDesigns
        freeSwag
        additionalFeatures
        onboarding
        support
        netTerms
        recommendedForTooltip
        recipientSupport
        onDemandSwagDesignsTooltip
        serviceFeeTooltip
        additionalFeaturesTooltip
        serviceFee
        sharedAdmins
      }
      orderedPreferenceKeys
    }
  }
`;

export const PACKAGE_FEATURES = gql`
  fragment PackageFeatures on PackageFeature {
    id
    name
    internalName
    intent
    description
    amount
    usageLimits
    displayOnFe
    onboardingRequired
    active
    roleId
    permissions
  }
`;
